import { render } from "./RodapeInfo.vue?vue&type=template&id=1e449f82&scoped=true"
import script from "./RodapeInfo.vue?vue&type=script&lang=js"
export * from "./RodapeInfo.vue?vue&type=script&lang=js"

import "./RodapeInfo.vue?vue&type=style&index=0&id=1e449f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e449f82"]])

export default __exports__